class TimeStamp {
  constructor(year, month, day, hour = 0, minute = 0) {
    // Vérifier que les paramètres sont des nombres valides
    this.year = parseInt(year).toString().padStart(4, '0');    // Année sur 4 chiffres
    this.month = parseInt(month).toString().padStart(2, '0');  // Mois sur 2 chiffres
    this.day = parseInt(day).toString().padStart(2, '0');      // Jour sur 2 chiffres
    this.hour = parseInt(hour).toString().padStart(2, '0');    // Heure sur 2 chiffres
    this.minute = parseInt(minute).toString().padStart(2, '0'); // minute sur 2 chiffres
  }

  static fromDate(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    return new TimeStamp(year, month, day, hour, minute);
  }

  static fromString(str) {
    if (!str) return null;
    
    // Gérer le format ISO YYYY-MM-DD
    const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) {
      const [, year, month, day] = isoMatch; // Utilisation de la virgule initiale pour ignorer le premier élément
      return new TimeStamp(year, month, day);
    }
    
    // Gérer le format standard YYYY-MM-DD-HH-MM
    const standardMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})-(\d{2})-(\d{2})$/);
    if (standardMatch) {
      const [, year, month, day, hour, minute] = standardMatch; // Utilisation de la virgule initiale pour ignorer le premier élément
      return new TimeStamp(year, month, day, hour, minute);
    }

    return null;
  }

  toString() {
    return `${this.year}-${this.month}-${this.day}-${this.hour}-${this.minute}`;
  }

  toStandardString() {
    return `${this.year}-${this.month}-${this.day}T${this.hour}:${this.minute}:00`;
  }

  toChartString() {
    return `${this.hour}:${this.minute}`;
  }

  toDate() {
    return new Date(
      parseInt(this.year),
      parseInt(this.month) - 1,
      parseInt(this.day),
      parseInt(this.hour),
      parseInt(this.minute)
    );
  }

  // Pour le tri et la comparaison
  static compare(a, b) {
    const aStr = a.toString();
    const bStr = b.toString();
    return aStr.localeCompare(bStr);
  }

  // Ajout de la méthode de formatage
  toFormattedDate() {
    const date = this.toDate();
    return date.toLocaleDateString('fr-FR');
  }
}

export default TimeStamp;
